import { BaseTone } from '../enums/tone.enum';

export interface ExceptionDTO {
  message: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
}

export class Exception {
  message: string;
  tone: BaseTone;
  options: { [key: string]: unknown };

  constructor(dto: ExceptionDTO) {
    this.message = dto.message;
    this.tone = dto.options?.tone;
    this.options = dto.options;
  }
}
